shadow$provide[31] = function(global,require,module,exports) {
module.exports=(ReactDOM);
};